import { Environment } from '@util/Environment';
import { StripeAccount } from 'hydra-data-types';
import { isNonEmptyString } from 'ts-utils';

const STRIPE_AU_PUBLISHABLE_KEY =
  Environment.PRODUCTION || Environment.STAGING
    ? 'pk_live_TChwCb8SJfyoHzlOM06Nvvh800XOUsRRxD'
    : 'pk_test_FKqLsewFYV2XCZ32W2l3VqAS00QkcEbCeD';

const STRIPE_US_PUBLISHABLE_KEY =
  Environment.PRODUCTION || Environment.STAGING
    ? 'pk_live_51Tl2ELRO5ZAZOBP1WO9NZj1DmyxeGwHeIVW8DrBJMweBcsxdl8pkrAaTwYfRXPaclwEnxEz3AZ8KTTWZvf7jQyet00AcnifY1r'
    : 'pk_test_51Tl2ELRO5ZAZOBP1uHTaMokdXgtLPfI4icqZevDlmGChQSBYCiCtM46sIGcAgjCLdFrNCNNAzlkKfVxxu3RJylcA00KK6QKHfj';

const STRIPE_PUBLISHABLE_KEYS: Record<StripeAccount, string> = {
  au: STRIPE_AU_PUBLISHABLE_KEY,
  us: STRIPE_US_PUBLISHABLE_KEY,
};

export function stripePublishableKey(account: StripeAccount): string {
  const key = STRIPE_PUBLISHABLE_KEYS[account];
  if (!isNonEmptyString(key)) {
    throw new Error(`Missing ${account.toUpperCase()} Stripe publishable key`);
  }
  return key;
}
